var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7083 25.375V13.2917H25.375V25.375H15.7083ZM3.625 15.7083V3.625H13.2917V15.7083H3.625ZM10.875 13.2917V6.04167H6.04167V13.2917H10.875ZM3.625 25.375V18.125H13.2917V25.375H3.625ZM6.04167 22.9583H10.875V20.5417H6.04167V22.9583ZM18.125 22.9583H22.9583V15.7083H18.125V22.9583ZM15.7083 3.625H25.375V10.875H15.7083V3.625ZM18.125 6.04167V8.45833H22.9583V6.04167H18.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverseIcon);
export default __webpack_public_path__ + "static/media/MetaverseIcon.1ab24e98f76bfd62fe9858a5ade7e82d.svg";
export { ForwardRef as ReactComponent };